module.exports = __webpack_public_path__ + "img/news_icon.svg";